import FupPersonListModelBase from '../_generated/modelBases/fup-person-list-model-base';

export default class FupPersonListModel extends FupPersonListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
